<template>
  <v-btn
    color="primary"
    :height="size.height"
    :width="size.width"
    :outlined="loyalty"
    rounded
    :style="{ background: loyalty ? 'white' : '' }"
    :disabled="redeemable && total_points_remaining - points < 0"
  >
    <span
      v-if="!redeemable"
      :class="small ? 'font-size-lg' : 'font-size-xxl'"
      class="pr-2"
      >+</span
    >
    <span
      :class="redeemable ? 'px-5' : ''"
      class="font-size-sm font-weight-bold text-none text-center"
      >{{ redeemable ? "Redeem" : "Add to Cart" }}</span
    >
  </v-btn>
</template>
<script>
import { mapGetters } from "vuex";

const size = {
  small: { height: 44, width: 118 },
  large: { height: 52 },
};

export default {
  name: "TobaccoButton",
  computed: {
    ...mapGetters("store", {
      total_points_remaining: "total_points_remaining",
    }),
    size() {
      return this.small ? size.small : size.large;
    },
  },
  props: {
    small: Boolean,
    loyalty: Boolean,
    redeemable: Boolean,
    points: Number,
  },
};
</script>
<style>
.remove-vuetify-button-opacity-on-focus:focus::before {
  opacity: 0 !important;
}
</style>
